import { ReactNode } from 'react'
import { Helmet } from 'react-helmet-async'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import getQueryParamsFromHash from '@functions/utils/getQueryParamsFromHash'
import parsePermittedQueryParams from '@functions/utils/parsePermittedQueryParams'

import useAdAccountGroup from '@hooks/useAdAccountGroup'

import PageHeader from '@components/PageHeader'

import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey?: string,
  adAccountGroupPayload: ReturnType<typeof useAdAccountGroup>,
  children: ReactNode,
}

const PageLayout = (props: PageLayoutProps) => {
  const {
    activeTabBarItemKey,
    adAccountGroupPayload: {
      adAccountGroup,
      urls: { adAccountGroupsIndexUrl },
    },
    children,
  } = props

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  return (
    <>
      <Helmet>
        <title>Edit AdAccountGroup | AIM Digital</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || adAccountGroupsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        tabBarItems={generateTabBarItems(adAccountGroup)}
        title="Edit Ad Account Group"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
